import React from 'react';
import { Link } from 'react-router-dom';
import { Star, Clock, Users, MapPin, TrendingUp } from 'lucide-react';
import { Badge } from '../ui/badge';
import { useApp } from '../../context/AppContext';

const TourCard = ({ tour }) => {
  const { getOpenDates } = useApp();
  const openDates = getOpenDates(tour.id);
  const hasAvailability = openDates.length > 0;

  return (
    <Link
      to={`/tour/${tour.id}`}
      className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 flex flex-col"
    >
      {/* Image */}
      <div className="relative h-64 overflow-hidden">
        <img
          src={tour.coverImage}
          alt={tour.name}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        
        {/* Badges */}
        <div className="absolute top-4 left-4 flex flex-wrap gap-2">
          <Badge className="bg-emerald-500 text-white hover:bg-emerald-600">
            {tour.difficulty}
          </Badge>
          {hasAvailability && (
            <Badge className="bg-amber-500 text-white hover:bg-amber-600">
              {openDates.length} Dates Available
            </Badge>
          )}
        </div>
      </div>

      {/* Content */}
      <div className="p-6 flex flex-col flex-grow">
        <h3 className="text-xl font-bold text-gray-900 group-hover:text-emerald-600 transition-colors mb-2">
          {tour.name}
        </h3>
        <p className="text-gray-600 text-sm mb-4 line-clamp-2 flex-grow">
          {tour.shortDesc}
        </p>

        {/* Meta Info */}
        <div className="grid grid-cols-2 gap-3 mb-4">
          <div className="flex items-center gap-2 text-sm text-gray-500">
            <Clock className="h-4 w-4 text-emerald-500" />
            {tour.duration}
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-500">
            <Users className="h-4 w-4 text-emerald-500" />
            {tour.groupSize}
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-500">
            <TrendingUp className="h-4 w-4 text-emerald-500" />
            {tour.altitude}
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-500">
            <MapPin className="h-4 w-4 text-emerald-500" />
            {tour.startPoint}
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between pt-4 border-t border-gray-100">
          <div className="flex items-center gap-1">
            <Star className="h-5 w-5 text-amber-500 fill-amber-500" />
            <span className="font-semibold">{tour.rating}</span>
            <span className="text-gray-400 text-sm">({tour.reviews})</span>
          </div>
          <span className="text-emerald-600 font-semibold group-hover:underline">View Details →</span>
        </div>
      </div>
    </Link>
  );
};

export default TourCard;
